import { Injectable } from '@angular/core';
import { Router, Event, NavigationEnd } from '@angular/router';
import { CanActivate } from '@angular/router';
import { ViewStateService } from './view-state.service';

@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(private router: Router, private viewState: ViewStateService) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        if (event.url.includes('assessment/')) {
          console.log("Inside if 1");
          this.viewState.isAssessmentModule(true);
        } else {
          this.viewState.isAssessmentModule(false);
        }
      }
    });
  }

  canActivate() {
    if (this.viewState.CurrentViewState.isUserLoggedIn) {return true;}
    this.router.navigate(['auth']);
    return false;
  }
}
